import { render, staticRenderFns } from "./toast-provider.vue?vue&type=template&id=6c38adaf"
import script from "./toast-provider.ts?vue&type=script&lang=ts&external"
export * from "./toast-provider.ts?vue&type=script&lang=ts&external"
import style0 from "./toast-provider.scss?vue&type=style&index=0&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c38adaf')) {
      api.createRecord('6c38adaf', component.options)
    } else {
      api.reload('6c38adaf', component.options)
    }
    module.hot.accept("./toast-provider.vue?vue&type=template&id=6c38adaf", function () {
      api.rerender('6c38adaf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/toast-provider/toast-provider.vue"
export default component.exports